import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './OnbaordPage.module.css';

const OnbaordPage = ({ setNeedOnbaord }) => {
  const sliderRef = useRef(null);
  const videoRefs = useRef([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showArrow, setShowArrow] = useState(false);
  const arrowDelays = [2000, 5000, 4000, 4000];

  const videos = [
    'onboarding_1.mp4',
    'onboarding_2.mp4',
    'onboarding_3.mp4',
    'onboarding_4.mp4',
    'onboarding_5.mp4',
  ];

  const settings = {
    infinite: false,
    speed: 200,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    beforeChange: (_, newIdx) => setCurrentSlide(newIdx),
  };

  // 슬라이드가 바뀔 때마다 3초 뒤에 deleteButton 보여주기
  useEffect(() => {
    setShowArrow(false);
    const delay = arrowDelays[currentSlide] ?? 3000;
    const timer = setTimeout(() => {
      if (currentSlide < videos.length - 1) {
        setShowArrow(true);
      }
    }, delay);
    return () => clearTimeout(timer);
  }, [currentSlide, videos.length]);

  // 비디오 재생/정지 로직 (이전과 동일)
  useEffect(() => {
    videoRefs.current.forEach((vid, idx) => {
      if (!vid) return;
      if (idx === currentSlide) {
        vid.play().catch(() => {});
      } else {
        vid.pause();
        vid.currentTime = 0;
      }
    });
  }, [currentSlide]);

  useEffect(() => {
    videoRefs.current.forEach(vid => {
      if (!vid) return;
      vid.preload = 'auto';
    });
    setTimeout(() => setCurrentSlide(0), 0);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.contents}>

          <Slider ref={sliderRef} {...settings} className={styles.usageSlider}>
            {videos.map((file, i) => (
              <video
                key={i}
                ref={el => (videoRefs.current[i] = el)}
                className={styles.contentImage}
                muted
                autoPlay
                playsInline
                webkitPlaysInline
                preload="auto"
                crossOrigin="anonymous"
              >
                <source
                  src={`https://hotple.s3.ap-northeast-2.amazonaws.com/onboard/${file}`}
                  type="video/mp4"
                />
              </video>
            ))}
          </Slider>

          {/* 인디케이터(이전 그대로) */}
          <div className={styles.indicators}>
            {currentSlide !== videos.length - 1 ? (
              <>
                <div
                  className={styles.cancleButton}
                >
                </div>

                {videos.map((_, idx) => (
                  <div
                    key={idx}
                    className={`${styles.indicator} ${
                      currentSlide === idx ? styles.activeIndicator : ''
                    }`}
                  />
                ))}

                {/* ↓ 여기를 이렇게 바꿔주세요 ↓ */}
                <div
                  className={`${styles.deleteButton} ${showArrow ? styles.pulse : ''}`}
                  onClick={() => {
                    setShowArrow(false);
                    sliderRef.current.slickNext();
                  }}
                >
                  <div className={styles.text}>▶</div>
                </div>
                {/* ↑ 여기까지 ↑ */}

              </>
            ) : (
              <div className={styles.kakaobutton} onClick={()=>{
                const redirectUri = `${window.location.origin}/auth/kakao/callback`;

                window.Kakao.Auth.authorize({ redirectUri });

                localStorage.setItem('finishOnbaord', 'true');
                setNeedOnbaord(false);
              }}>
                <img className={styles.iconcloseFilled2} alt="" src="images/kakao.svg" />
                <div className={styles.text2}>카카오로 시작하기</div>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default OnbaordPage;
